export default __webpack_public_path__ + "static/media/vm-img1.2efe7c0f.png";